import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import T from "i18n";
import Button from "./atoms/Button";

const Wrapper = styled.form`
@media print {
  display:none;      
}
  display: grid;
  grid-template-columns: 1fr 120px;
  grid-gap: ${({ theme }) => theme.spacer}px;

  background-color: ${({ theme }) => theme.palette.blue.lighter};
  padding: ${({ theme }) => theme.spacer}px;

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${({ theme }) => `${theme.spacer}px ${theme.spacer * 4}px`};
  }

  input {
    border: 1px solid ${({ theme }) => theme.palette.grey.light};
    border-radius: ${({ theme }) => theme.radius.small}px;
  }
`;

const EmailForm = ({ className, onSubmit, disabled }) => {
  const classes = ["EmailForm"];
  if (className) classes.push(className);

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(e.target.email.value);
  }

  return (
    <Wrapper className={classes.join(" ")} onSubmit={handleSubmit}>
      <input
        type="email"
        name="email"
        autoComplete="email"
        placeholder={T({ path: "email.placeholder" })}
        required
      />
      <Button type="submit" disabled={disabled}>
        {T({ path: "email.sendButton" })}
      </Button>
    </Wrapper>
  );
};

EmailForm.displayName = "EmailForm";

EmailForm.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

EmailForm.defaultProps = {
  className: null,
  disabled: false,
};

export default EmailForm;
